import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BaseDirective } from '@egym/ngx-adm-int';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { DownloadService } from 'src/app/service/download.service';
import { GymFinderService } from 'src/app/service/gymfinder.service';

@Component({
  selector: 'gymfinder-gymfinder',
  templateUrl: './gymfinder.component.html',
  styleUrls: ['./gymfinder.component.scss'],
  standalone: false,
})
export class GymfinderComponent extends BaseDirective<void> {
  numberOfReports = [1];

  constructor(
    snackBar: MatSnackBar,
    private router: Router,
    private gymFinderService: GymFinderService,
    private downloadService: DownloadService
  ) {
    super(snackBar);
  }

  navigateToGymId(gymId: number) {
    if (gymId > 0) {
      this.router.navigate([
        '/gym-location',
        'gymfinder',
        'gym',
        gymId,
        'details',
      ]);
    }
  }

  downloadCsv() {
    this.loading = true;
    this.error = undefined;

    this.gymFinderService
      .exportGymsAsCsv()
      .pipe(catchError(error => this.parseBlobError(error)))
      .subscribe({
        next: csv => {
          this.downloadService.downloadBlob(csv, 'allGyms.csv');
          this.loading = false;
        },
        error: error => {
          this.loading = false;
          this.error = error;
          this.openSnackBar('Error exporting gyms!');
        },
      });
  }

  addGymReport() {
    this.numberOfReports.push(1);
  }

  // exportGymsAsCsv is a blob request, so a failed request's error body is a Blob too - re-read it as text/JSON.
  private parseBlobError(error: unknown) {
    if (
      !(error instanceof HttpErrorResponse) ||
      !(error.error instanceof Blob)
    ) {
      return throwError(() => error);
    }

    return from(error.error.text()).pipe(
      switchMap(text => {
        let parsedBody: unknown = text;
        try {
          parsedBody = text ? JSON.parse(text) : text;
        } catch {
          // Body wasn't JSON - fall back to the raw text.
        }
        return throwError(
          () =>
            new HttpErrorResponse({
              error: parsedBody,
              headers: error.headers,
              status: error.status,
              statusText: error.statusText,
              url: error.url ?? undefined,
            })
        );
      })
    );
  }
}
